// トップページ：ピンポイント検索

jQuery(function($){
  $('#pinpoint .selector').each(function(){
    var self = $(this);
    var select = $('a.select', self);
    var pulldown = $('.pulldown', self);
    var select_value = $('span', select);
    
    select.click(function(e){
      $('.pulldown').hide();
      pulldown.show();
      $('a.select').removeClass('focus');
      $(this).addClass('focus');
      
      e.stopPropagation();
      return false;
    });
    
    $('a', pulldown).click(function(){
      var text = $(this).text();
      
      select_value.text(text);
      
      $('a.selected',pulldown).removeClass('selected');
      $('a.focus').removeClass('focus');
      $(select, this).addClass('selected');
      pulldown.hide();
      
      var params = $(this).data('params');
      for (var key in params) {
          $('#'+key).val(params[key]);
      }
      
      return false;
    });
    
    $('body').click(function(){
      $('a.focus').removeClass('focus');
      $('.pulldown').hide();
    });
  });

  $('#pinpoint select').click(function(){
    $('#pinpoint .selected').text($('option:selected',this).text());
  }).trigger('change');
});

jQuery(function($){
  $('#otherSearch > a').click(function(){
    $(this).toggleClass('on');
    return false;
  });
  $('body').click(function(){
    if ($('#otherSearch > a').hasClass('on')) {
      $('#otherSearch > a').removeClass('on');}
  })
});